import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyCnYVPjG7qH4KTV14LDI2OTjc3WA0yCTm4",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "omevita-7ff00.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "omevita-7ff00",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "omevita-7ff00.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "39609656397",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:39609656397:web:b61a4cbe28c8c07c112804",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-8Y43Q0S7EF"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication
export const auth = getAuth(app);

export default app;
